const SET_UPDATE_CHAT_MESSAGES = 'nibi/auth/SET_UPDATE_CHAT_MESSAGES';
const SET_CHAT_NOTIFICATION = 'nibi/auth/SET_CHAT_NOTIFICATION';

const initialState = {
  chatNotification: false,
  chatNotificationNumber: 0,
  updateChatMessages: false
};

export default function reducer(state = initialState, action) {

  const payload = action.payload;

  switch (action.type) {
    case SET_CHAT_NOTIFICATION:
      return {
        ...state,
        chatNotification: payload.showNotifications || false,
        chatNotificationNumber: payload.number || 0
      };
    case SET_UPDATE_CHAT_MESSAGES:
      return {
        ...state,
        updateChatMessages: payload.updateChatMessages || false
      };
    default:
      return state;
  }
}

export function setUpdateChatMessages(payload) {
  return { type: SET_UPDATE_CHAT_MESSAGES, payload };
}

export function setChatNotification(payload) {
  return { type: SET_CHAT_NOTIFICATION, payload };
}
